"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var ThemedComponent_1 = require("../ThemedComponent");
var Typography_1 = require("../Typography");
var styles_1 = require("./styles");
var RadioAccordion = function (_a) {
    var label = _a.label, index = _a.index, helpText = _a.helpText, selectedIdx = _a.selectedIdx, setSelectedIdx = _a.setSelectedIdx, showButton = _a.showButton, icon = _a.icon, fullWidth = _a.fullWidth, disabled = _a.disabled, dropdown = _a.dropdown;
    var getLabelColor = function (checked, disabled) {
        if (disabled) {
            return 'weaker';
        }
        else if (checked) {
            return 'on-base-active';
        }
        else {
            return 'base';
        }
    };
    var getBorderColor = function (checked, disabled) {
        if (disabled) {
            return 'weak';
        }
        else if (checked) {
            return 'active';
        }
        else {
            return 'base';
        }
    };
    var checked = selectedIdx === index;
    var handleOnClick = function () {
        if (!disabled) {
            setSelectedIdx(index);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("section", __assign({ className: 'squid-flex squid-flex-col' }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ className: (0, classnames_1.default)((0, styles_1.getRadioAccordionClasses)({
                        checked: checked,
                        disabled: disabled,
                        fullWidth: !!fullWidth,
                    }), 'squid-flex squid-text-start'), onClick: handleOnClick }, { children: [icon && ((0, jsx_runtime_1.jsx)("section", __assign({ className: "squid-pr-component-radio-space-base" }, { children: icon }))), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "squid-flex squid-flex-col squid-flex-1 squid-w-full" }, { children: [(0, jsx_runtime_1.jsxs)("section", __assign({ className: "squid-flex squid-justify-between" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ ariaLevel: null, color: getLabelColor(checked, disabled), className: (0, classnames_1.default)({
                                                'squid-text-center ': !!helpText,
                                            }) }, { children: label })), showButton && ((0, jsx_runtime_1.jsx)(ThemedComponent_1.ThemedComponent, { borderColor: getBorderColor(checked, disabled), className: (0, classnames_1.default)('squid-rounded-xl squid-h-4 squid-w-4 squid-shrink-0', checked ? 'squid-border-4' : 'squid-border-2') }))] })), helpText && ((0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "p", role: '', ariaLevel: null, size: "sm", className: (0, classnames_1.default)('squid-flex', 'text-start', disabled
                                        ? 'squid-text-alias-color-text-disabled'
                                        : 'squid-text-alias-color-text-weakest') }, { children: helpText })))] }))] })), dropdown && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-ml-3 squid-pl-3 squid-border-l squid-border-alias-color-border-base squid-mt-3', checked ? 'squid-block' : 'squid-hidden') }, { children: dropdown })))] })) }));
};
exports.RadioAccordion = RadioAccordion;
